import React, { useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, themeBalham } from 'ag-grid-community';
import { FavoritePointOfSaleDTO } from '../../../utils/types/objects/FavoritePointOfSaleDTO';

const FavoritePointsOfSaleGrid: React.FC<{ items: FavoritePointOfSaleDTO[] }> = ({ items }) => {
    const [columnDefs] = useState<ColDef<FavoritePointOfSaleDTO>[]>([
        { field: 'name', headerName: 'Nom' },
        {
            field: 'nbDeliveries',
            headerName: 'Nombre de livraisons',
            type: 'numericColumn',
            valueFormatter: (p) => (p.value ? new Intl.NumberFormat('fr-FR').format(p.value) : ''),
        },
        {
            field: 'totalQty',
            headerName: 'Quantité totale (L)',
            type: 'numericColumn',
            valueFormatter: (p) => (p.value ? new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2 }).format(p.value) : ''),
        },
    ]);

    return (
        <div style={{ width: '100%', height: 200 }}>
            <AgGridReact theme={themeBalham} rowData={items} columnDefs={columnDefs} defaultColDef={{ flex: 1, resizable: true, minWidth: 100 }} overlayNoRowsTemplate="<span style='padding: 10px;'>Aucune donnée ...</span>" />
        </div>
    );
};

export default FavoritePointsOfSaleGrid;
